module.exports = __webpack_public_path__ + "img/f.1f046740.jpg";